import React, { useState, useEffect } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../customModal/customModal";
import { Button, Image } from "../../ui";
import { Button as CustomBtn } from "../../ui";
import { useFetchAllPaymentQuery } from "../../store/api/apiSlice";

function Payment() {
  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_SERVER_URL;

  const xAuthToken =
    JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
  const stripe = useStripe();
  const elements = useElements();
  const location = useLocation();
  const { priceId, email, firstName, lastName, product } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [agreeToPrivacyPolicy, setAgreeToPrivacyPolicy] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [email1, setEmail1] = useState("");
  const [cardholderName, setCardholderName] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("US");
  const [countries, setCountries] = useState([]);
  const [cardholderError, setCardholderError] = useState("");

  const [zipCodeError, setZipCodeError] = useState("");
  const [countryError, setCountryError] = useState("");

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch("https://restcountries.com/v3.1/all");
        const data = await response.json();
        const countryList = data.map((country) => ({
          code: country.cca2,
          name: country.name.common,
        }));
        countryList.sort((a, b) => a.name.localeCompare(b.name));
        setCountries(countryList);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);
  const handleSubscribe = async () => {
    setLoading(true);
    setError(null);

    setCardholderError("");

    setZipCodeError("");
    setCountryError("");
    if (!cardholderName) {
      setCardholderError("Cardholder name is required.");
      setLoading(false);
      return;
    }
    if (!selectedCountry) {
      setCountryError("Country is required.");
      setLoading(false);
      return;
    }
    if (!postalCode) {
      setZipCodeError("Zip code is required.");
      setLoading(false);
      return;
    }

    if (!stripe || !elements) {
      setError("Stripe is not properly initialized.");
      setLoading(false);
      return;
    }
    if (!agreeToPrivacyPolicy) {
      setError("Accept the terms and policy.");
      setLoading(false);
      return;
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: {
        name: cardholderName,

        address: {
          country: selectedCountry,
          postal_code: postalCode,
        },
      },
    });

    if (error) {
      console.error(error, "error");
      setError(error.message);
      setLoading(false);
      return;
    }
    const response = await fetch(`${baseUrl}/api/stripe/create-subscription`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "secret-key": process.env.REACT_APP_SECRET_KEY || "",
        "x-auth-token": xAuthToken,
      },
      body: JSON.stringify({
        name: `${firstName} ${lastName}`,
        email: email,
        payment_method_id: paymentMethod.id,
        priceId: priceId,
      }),
    });

    const data = await response.json();
    if (response.ok) {
      setOpenModal(true);
      setSuccess("Subscribed successfully!");
    } else {
      setError(data.message || "Something went wrong.");
    }

    setLoading(false);
  };
  const closeModal = () => {
    setOpenModal(false);
    setSuccess("");
    navigate("/");
  };
  const handleBackClick = () => {
    navigate("/membership");
  };
  return (
    <div className="package_Conatiner">
      <div className="title-section packaga_title_section">
        <Image
          className="membership_title_image"
          path="/images/headericon.png"
          alt="Logo"
        />
        <h2 className="pb-0">College Sports Fan Association</h2>
      </div>
      <div className="Main_payment_div">
        <div className="col lg-6 md-6 package_productName">
          <div className="card-content-payment">
            <p style={styles.title}>{product?.name}</p>

            <div>
              <span className="amount">
                ${(product?.pricing_list[0]?.unit_amount / 100).toFixed(2)}
              </span>
              <span className="period">/ year</span>
            </div>

            <p style={styles.description2}>{product?.description}</p>
          </div>
        </div>

        <div className="col md-4 lg-4 package_productName">
          <div style={styles.container}>
            <h1 style={styles.title}>ANNUAL CSFA MEMBERSHIP DUES</h1>
            <p style={styles.description2}>
              Enter card information below to become a CSFA-US Team Player.
            </p>
            <div style={styles.cardContainer}>
              <div className="package_CardDetail_cont">
                <div className="package_CardDetail_div">
                  <h1 style={styles.description}>Card Details</h1>
                  <CardNumberElement
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                          color: "#424770",
                          fontFamily: "Arial, sans-serif",
                          "::placeholder": {
                            color: "#aab7c4",
                          },
                        },
                        invalid: {
                          color: "#9e2146",
                        },
                      },
                    }}
                  />
                </div>
                <div className="package_CardDetail_div_expiry">
                  <h1 style={styles.description}>Expiry Date</h1>
                  <CardExpiryElement
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                          color: "#424770",
                          fontFamily: "Arial, sans-serif",
                          "::placeholder": {
                            color: "#aab7c4",
                          },
                        },
                        invalid: {
                          color: "#9e2146",
                        },
                      },
                    }}
                  />
                </div>
                <div className="package_CardDetail_div_expiry">
                  <h1 style={styles.description}>CVC</h1>
                  <CardCvcElement
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                          color: "#424770",
                          fontFamily: "Arial, sans-serif",
                          "::placeholder": {
                            color: "#aab7c4",
                          },
                        },
                        invalid: {
                          color: "#9e2146",
                        },
                      },
                    }}
                  />
                </div>
              </div>
              <div className="StripeElement">
                <div className="package_stripPayment">
                  <label className="package_stripPayment_label">
                    Cardholder name
                  </label>
                  <input
                    type="text"
                    placeholder="Cardholder name"
                    className="packaga_zipcode_cardHolder"
                    value={cardholderName}
                    onChange={(e) => setCardholderName(e.target.value)}
                  />
                  {cardholderError && (
                    <p style={styles.error}>{cardholderError}</p>
                  )}
                </div>
                <div className="package_stripPayment_cardholder">
                  <div className="package_stripPayment_card_div">
                    <label className="package_stripPayment_card_label">
                      Country
                    </label>
                    <select
                      className="package_stripPayment_card_select"
                      value={selectedCountry}
                      onChange={(e) => setSelectedCountry(e.target.value)}
                    >
                      <option
                        className="package_stripPayment_card_option"
                        value="US"
                      >
                        United States
                      </option>
                      {countries.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    {countryError && <p style={styles.error}>{countryError}</p>}
                  </div>
                  <div className="packaga_zipcode">
                    <label className="packaga_zipcode_label">Zip code </label>
                    <input
                      type="text"
                      placeholder="Zip Code"
                      className="packaga_zipcode_input"
                      value={postalCode}
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                    {zipCodeError && <p style={styles.error}>{zipCodeError}</p>}
                  </div>
                </div>
              </div>
            </div>
            <p style={styles.description2}>
              CSFA Uses STRIPE to process your card transaction. STRIPE is a
              world-wide recognized leader in online payments and none of your
              card information is retained or stored by CSFA or STRIPE
            </p>
            <div style={styles.checkboxContainer}>
              <input
                type="checkbox"
                id="privacyPolicyCheckbox"
                checked={agreeToPrivacyPolicy}
                onChange={() => setAgreeToPrivacyPolicy(!agreeToPrivacyPolicy)}
              />
              <div>
                <label
                  htmlFor="privacyPolicyCheckbox"
                  style={styles.checkboxLabel}
                >
                  Do you agree to the{" "}
                  <a
                    href="/PrivacyPolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    privacy policy
                  </a>{" "}
                  of this platform?
                </label>
              </div>
            </div>
            <CustomBtn
              onClick={handleSubscribe}
              loading={loading}
              style={styles.button}
            >
              Subscribe
            </CustomBtn>
            {error && <p style={styles.error}>{error}</p>}
            {success && <p style={styles.success}>{success}</p>}
            <CustomModal
              style={{ alignItems: "center" }}
              isOpen={openModal}
              onClose={closeModal}
            >
              <p style={styles.success}>{success}</p>
              <p>Your payment has done successfully.</p>

              <button style={styles.button} onClick={closeModal}>
                Back
              </button>
            </CustomModal>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "30px",
        }}
      >
        <Button
          onClick={handleBackClick}
          style={{ marginTop: "10px", width: "fit-content" }}
          className="btn-primary"
        >
          Back
        </Button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "500px",

    padding: "20px",

    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px",
    color: "#333",
  },
  description2: {
    fontSize: "14px",
    marginBottom: "20px",
    color: "#666",
  },
  description: {
    fontSize: "14px",
    marginBottom: "10px",
    marginTop: "20px",
    color: "#666",
    textAlign: "start",
  },
  cardContainer: {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "10px",
    marginBottom: "20px",
    backgroundColor: "#fafafa",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "10px",
  },
  checkboxLabel: {
    marginLeft: "8px",
    fontSize: "12px",
    padding: "0px",
  },
  button: {
    width: "fit-content",
    backgroundColor: "#ce1126",
    color: "#ffffff",
    fontSize: "16px",
    padding: "10px 20px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  buttonHover: {
    backgroundColor: "#4359b5",
  },
  error: {
    color: "red",
    marginTop: "15px",
    textAlign: "justify",
  },
  success: {
    color: "green",
    marginTop: "15px",
  },
};

export default Payment;
